import { useState } from "react"
import { api } from "../../../api/api"
import { Toast } from "../../../utils/Toast"

export function ModalReportNfe() {
  const [state, setState] = useState({
    starDate: '',
    endDate: '',
    status: 'emitidas',
    email: '',
  })

  async function xmlLote() {
    const response = await api.get(`/nfce/report/xml-lote?starDate=${state.starDate}&endDate=${state.endDate}&status=${state.status}&email=${state.email}`)

    document.getElementById("close-modal-report-nfe").click()

    if (response.status === 200) {
      return Toast.success('Gerado com sucesso')
    }

    return Toast.success('Erro ao gerar relatório.')
  }


  return (
    <>
      <div className="modal fade admin-form-modal" id="modalReportNFe" tabIndex="-1" aria-labelledby="modalReportNFeLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modalReportNFeLabel">Relatório fiscal</h5>
              <button type="button" className="btn-close" onClick={()=>{
                  setState({
                    starDate: '',
                    endDate: '',
                    status: 'emitidas',
                    email: '',
                  })
              }} data-bs-dismiss="modal" aria-label="Close" id="close-modal-report-nfe"></button>
            </div>
            <div className="modal-body">
              <div>
                <div>
                  <label htmlFor="report-nfe-email">E-mail</label>
                  <input id="report-nfe-email" type="email" value={state.email} onChange={(e) => setState({ ...state, email: e.target.value })} placeholder="financeiro@empresa.com" />
                </div>
                <div>
                  <label htmlFor="report-nfe-status">Status</label>
                  <select id="report-nfe-status" value={state.status} onChange={(e) => setState({ ...state, status: e.target.value })}>
                    <option value='emitidas'>Emitidas</option>
                    <option value='canceladas'>Canceladas</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="report-nfe-start">Início</label>
                  <input id="report-nfe-start" value={state.starDate} onChange={(e) => setState({ ...state, starDate: e.target.value })} type="date" />
                </div>
                <div>
                  <label htmlFor="report-nfe-end">Fim</label>
                  <input id="report-nfe-end" value={state.endDate} type="date" onChange={(e) => setState({ ...state, endDate: e.target.value })} />
                </div>
                <div>
                  <button className="admin-primary-button w-100" onClick={() => xmlLote()}>Enviar relatório</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
